/**
 * EG Search (Meilisearch) – shared config + tiny helpers.
 *
 * Exposes `window.EGSearchConfig` for the other theme scripts.
 */
window.EGSearchConfig = (function () {
  'use strict';

  // API base URL for the search service.
  const API_BASE = window.SEARCH_API_URL || 'https://your-api.onrender.com';

  // Autocomplete: "Popular searches" chips shown when the box is empty.
  const POPULAR_SEARCHES = ['greenstalk', 'garlic', 'grow bags', 'seeds', 'trellis', 'strawberry'];

  // Autocomplete: quick-access cards shown on the right side of the dropdown.
  const QUICK_ACCESS_FALLBACK = [
    {
      title: 'Preorder Garlic',
      image: 'https://cdn.shopify.com/s/files/1/1337/8159/files/garlic-search-image.jpg?v=1753734859',
      url: '/collections/garlic',
      style: 'sales-banner'
    },
    {
      title: 'Raised Garden Beds',
      image: 'https://cdn.shopify.com/s/files/1/1337/8159/files/z_MG_8463.jpg?v=1732045883',
      url: '/collections/birdies-original',
      style: 'new-collection'
    },
    {
      title: 'Irrigation for Beds',
      image: 'https://cdn.shopify.com/s/files/1/1337/8159/files/DSC06496.jpg',
      url: '/collections/irrigation',
      style: 'new-collection'
    },
    {
      title: 'How Can We Help?',
      style: 'help',
      links: [
        { title: 'Track My Order', url: '/pages/tracking' },
        { title: 'Returns', url: 'https://epic-gardening.loopreturns.com/#/' },
        { title: 'FAQ', url: '/pages/faq' }
      ]
    }
  ];
  const QUICK_ACCESS = Array.isArray(window.EG_SEARCH_QUICK_ACCESS)
    ? window.EG_SEARCH_QUICK_ACCESS
    : QUICK_ACCESS_FALLBACK;

  // Small utilities used across modules.
  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function highlightMatch(text, query) {
    if (!text || !query) return escapeHtml(text || '');
    const regex = new RegExp(`(${escapeRegex(query)})`, 'gi');
    return escapeHtml(text).replace(regex, '<mark>$1</mark>');
  }

  // Public surface.
  return {
    API_BASE,
    POPULAR_SEARCHES,
    QUICK_ACCESS,
    escapeHtml,
    escapeRegex,
    highlightMatch
  };
})();
